import React from 'react';
import classNames from 'classnames';
import { LazyImage } from 'project/lazy-image';
import { SpriteSvg } from 'project/sprite-svg';
import { viewTypes } from '../enums';
import { FLAG_IMAGE_PATH } from 'general/js/constants';

const LeaderboardHbhButton = ({ view, toggleHoleByHoleView }) => {
    const stateCss = classNames({
        'is-active': view === viewTypes.HOLE_BY_HOLE,
    });

    return (
        <button
        className={`leaderboard__hbh-button button-round button-round--toggle is-border-white ${stateCss}`}
            type="button"
            onClick={toggleHoleByHoleView}
        >
            <span className="button-content button-content--icon">
                <span>Hole By Hole</span>
                {
                    view === viewTypes.HOLE_BY_HOLE &&
                    <SpriteSvg
                        childCss={'leaderboard__hbh-button-icon-close'}
                        iconName={'cross'}
                        width="10"
                        height="10"
                    />
                }
                {
                    view !== viewTypes.HOLE_BY_HOLE &&
                    <span className="leaderboard__hbh-button-icon-flag-wrapper of-contain">
                        <LazyImage image={FLAG_IMAGE_PATH} />
                    </span>
                }
            </span>
        </button>
    );
};

export default LeaderboardHbhButton;
